// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PageListTitle_wrapper__ezpFY"};